import React from 'react';
import T from 'prop-types';
import { TimePicker as AntdTimePicker } from 'antd';
import { PopoverWithContext } from '../popover-with-context';

export const TimePicker = ({
  format,
  placeholder,
  size,
  ...rest
}) => (
  <PopoverWithContext
    component={AntdTimePicker}
    format={format}
    placeholder={placeholder}
    size={size}
    {...rest}
  />
);

TimePicker.propTypes = {
  format: T.string,
  placeholder: T.string,
  size: T.string,
};

TimePicker.defaultProps = {
  format: 'HH:mm',
  placeholder: 'HH:MM',
  size: 'large',
};



// WEBPACK FOOTER //
// ./src/components/popovers/time-picker/index.js